import { logoutUser } from './logoutUser';
import { SESSION_LOGOUT_TIME, SESSION_WARN_TIME } from '../../constants/timers';
import { SessionStore } from '../../constants/sessionStore';
import { useBasicDetails } from '../../store';
import { getCookie } from './cookies';
import { useHistory } from 'react-router-dom';
import { routeMappings } from './../../constants/routeMappings';
import { useAppSelector } from '../../redux-store/hook';

export const clearUserSessionTimers = (): void => {
  const warningTimer = sessionStorage.getItem(SessionStore.sessionWarningTimer);
  const logoutTimer = sessionStorage.getItem(SessionStore.sessionLogoutTimer);

  const sessionWarningTimer = warningTimer ? JSON.parse(warningTimer) : undefined;
  const sessionLogoutTimer = logoutTimer ? JSON.parse(logoutTimer) : undefined;

  clearTimeout(sessionWarningTimer);
  clearTimeout(sessionLogoutTimer);
  sessionStorage.removeItem(SessionStore.sessionWarningTimer);
  sessionStorage.removeItem(SessionStore.sessionLogoutTimer);
};

export function useActivateUserSessionTimers(): () => void {
  const candidate = useAppSelector((state) => state.candidate);
  const { updateUserInactivity } = useBasicDetails();
  const history = useHistory();
  return (): void => {
    const sessionWarningTimer = setTimeout(() => {
      // show warning message, set user session inactive to true
      updateUserInactivity(true);
      console.info('[USER INACTIVE]: STARTED AUTOMATIC LOGOUT IN 60 SECONDS');
      const sessionLogoutTimer = setTimeout(() => {
        logoutUser(candidate).then((res) => {
          const tcPlusFlow = getCookie('TcPlusFlag') === '1';
          if (tcPlusFlow && res.data && res.data.Success) history.push(routeMappings['LOGIN']);
        });
        sessionStorage.setItem(SessionStore.logoutDueToInactivity, 'true');
        clearUserSessionTimers();
      }, SESSION_LOGOUT_TIME);
      sessionStorage.setItem(SessionStore.sessionLogoutTimer, JSON.stringify(sessionLogoutTimer));
    }, SESSION_WARN_TIME);
    sessionStorage.setItem(SessionStore.sessionWarningTimer, JSON.stringify(sessionWarningTimer));
  };
}
